const ENDPOINT_URL = 'v3/user/docs'

export const state = () => ({
  docs: []
})

export const getters = {
  getList: (state) => {
    return state.docs
  },
  getDocBySearchType: (state) => (search_type) => {
    let docsInSearch = {
      gibdd: /^(ctc|vu|licence_plate)$/,
      fssp: /^fio_birth_date_requisite$/,
      fns: /^(passport|inn)$/
    }
    return state.docs.filter(item => docsInSearch[search_type].test(item.document_type))
  },
  getCount: (state) => {
    return state.docs.length
  },
  getCountGibdd: (state, getters) => {
    return getters.getDocBySearchType('gibdd').length
  }
}

export const mutations = {
  /**
   * Заменяем список документов на новый
   *
   * @param {*} state - state vuex
   * @param {*} docs - новый список документов
   */
  getList (state, docs) {
    if (docs) {
      state.docs.splice(0, state.docs.length, ...docs)
    }
  },
  /**
   * Добавляем документ если его нет
   *
   * @param {*} state - state vuex
   * @param {*} doc - новый документ
   */
  save (state, doc) {
    if (state.docs.some(i => i.id === doc.id)) {
      return
    }
    state.docs.unshift(doc)
  },
  /**
   * Обновляем если документ есть
   *
   * @param {*} state - state vuex
   * @param {*} doc - новый документ
   */
  update (state, doc) {
    Object.assign(state.docs.find(item => item.id === doc.id), doc)
  },
  /**
   * Удаляем если документ есть
   *
   * @param {*} state - state vuex
   * @param {*} docId - id документа
   */
  delete (state, docId) {
    state.docs.splice(state.docs.findIndex(item => item.id === docId), 1)
  }
}

export const actions = {
  getList ({ commit }) {
    return this.$api.$get(ENDPOINT_URL).then((response) => {
      commit('getList', response.map(item => {
        /** если additional_fields пустой, то бэк отдает массив - это все ломает */
        item.additional_fields = Array.isArray(item.additional_fields) ? {} : item.additional_fields

        /** убираем лишние пробелы по бокам в фио */
        if (item.document_value.fio) {
          item.document_value.fio = item.document_value.fio.trim()
        }

        /** с бека регион приходит и стройкой, и числом - делаем регион строкой */
        if (item.document_value.region_id && typeof item.document_value.region_id === 'number') {
          item.document_value.region_id = String(item.document_value.region_id)
        }
        return item
      }))
    })
  },
  save ({ commit }, doc) {
    return this.$api.$post(ENDPOINT_URL, doc).then((response) => {
      commit('save', response)
    })
  },
  update ({ commit }, { docId, newVal }) {
    return this.$api.$patch(ENDPOINT_URL + `/${docId}`, newVal).then((response) => {
      commit('update', response)
    })
  },
  delete ({ commit }, docId) {
    return this.$api.$delete(ENDPOINT_URL + `/${docId}`).then(() => {
      commit('delete', docId)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
